/**
 * Cache-bust version for /docs/economist-user-manual.pdf.
 *
 * CF Pages serves the PDF with `cache-control: public, max-age=14400`
 * (4 hours). Without a query param, browsers serve the stale cached PDF
 * for 4 hours after the user's last fetch — even after we redeploy a
 * new version. Bumping this string forces a fresh fetch.
 *
 * Convention: YYYYMMDD of the PDF's last rebuild. Bump every time
 * `pnpm manual:rebuild` produces a new `apps/web/public/docs/economist-user-manual.pdf`.
 */
export const MANUAL_VERSION = '20260629';

export const MANUAL_PDF_URL = `/docs/economist-user-manual.pdf?v=${MANUAL_VERSION}`;
